import { styled, TableCell, TableRow } from "@material-ui/core";
import { mutantColors } from "../../assets/styles/themes/default";
export const StyledTableRow = styled(TableRow)(() => ({
	height: "32px",
	"&.MuiTableRow-root": {
		maxHeight: "32px !important"
	},
	"&:nth-of-type(odd)": {
		backgroundColor: "#FAFAFA"
	}
}));

export const StyledTableCell = styled(TableCell)(() => ({
	"&.MuiTableCell-head": {
		fontFamily: "'Poppins', sans-serif",
		fontSize: "14px",
		lineHeight: "24px",
		color: mutantColors.d_blue_4,
		height: "64px",
		padding: "0 16px",
		background: "#fff",
		borderBottom: "1px solid #A3A3A3",
		fontWeight: "bold",
	},
	"&.MuiTableCell-root.MuiTableCell-body": {
		fontFamily: "'Maison Neue Light', sans-serif",
		fontWeight: "normal",
		fontSize: "14px",
		lineHeight: "21px",
		color: "#4D4C4D",
		maxHeight: "32px",
		padding: "14px 7px"
	},
	"&.MuiTableCell-root.MuiTableCell-body:not(:last-child)": {
		// borderRight: "0.25px solid #ddd"
	},
	"&:last-child td, &:last-child th": {
		border: 0
	},
	"&:last-child audio::-webkit-media-controls-play-button": {
		'-webkit-appearance': 'media-play-button',
		backgroundColor: '#ff0',
	},
}));
